import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormDataService } from './form-data.service';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { response } from 'express';
import { WindowService } from './window.service';
import { ThankYouRouteService } from './thank-you-route.service';
import { VirtualPageViewService } from './virtual-page-view.service';
import { TelemetryService } from './telemetry.service';


@Injectable({
  providedIn: 'root'
})
export class FormSubmissionService {
  private saving = false;
  private jornayaTokenRuntimeCache = '';

  private leadSubject = new BehaviorSubject<any>({});
  $leadData = this.leadSubject.asObservable();

  private lead$ = new BehaviorSubject<any>(null);
  public lead: Observable<any> = this.lead$.asObservable();

  environment: any = {
    apiBaseUrl: "https://landinghelper.azurewebsites.net/api",
    apiToken: "79148e5b-5a49-49b2-8eb1-1eebcec31730"
  }

  constructor(
    private http: HttpClient,
    private formDataService: FormDataService,
    private router: Router,
    private windowService: WindowService,
    private thankYouRouteService: ThankYouRouteService,
    private virtualPageViewService: VirtualPageViewService,
    private telemetryService: TelemetryService,
    private window: WindowService,
  ) { 



  }

  private get isBrowser(): boolean {
    return !!this.windowService.window;
  }

  private get storage(): Storage | null {
    return this.window.window?.localStorage ?? null;
  }

  async submitForm(site: string): Promise<void> {
    if (this.saving) return;
    this.saving = true;

    try {
      const formData = this.formDataService.getCurrentFormData();
      const lead = await this.prepareLeadDataForFinalSubmit(formData, site);
      const headers = this.getRequestHeaders();
      const requestData = {
        VerticalType: formData.VerticalID,
        EventID: this.generateUUID(),
        GoogleImgValid: null,
        Lead: lead,
        Site: 'https://www.fharateguide8.com/'
      };
      const saveLeadURL = this.getSubmissionUrl();
      // const response = 'null';
      const response = await this.http.post(saveLeadURL, requestData, { headers }).toPromise();
      
      await this.handleSubmissionResponse(response, lead);

      

    } catch (error) {
      console.error('Submission error:', error);
      var response = 'null';
      var lead = this.formDataService.getCurrentFormData();
      await this.handleSubmissionResponse(response, lead);
    } finally {
      this.saving = false;
    }
  }

  private async prepareLeadDataForFinalSubmit(formData: any, site: string): Promise<any> {
    const lead = this.prepareLeadData(formData, site);
    const finalToken = await this.getJornayaTokenForFinalSubmit();

    if (finalToken) {
      lead.LeadIDTocken = finalToken;
      lead.JornayaToken = finalToken;
      this.logJornayaDebug('form-submission:final-token-applied', {
        tokenLen: finalToken.length,
        usedWait: true,
      });
    } else {
      this.logJornayaDebug('form-submission:final-token-empty-after-check', {
        usedWait: true,
      });
    }

    return lead;
  }

  prepareLeadData(formData: any, site: string): any {
    const lead = { ...formData };
    
    lead.Site = site;
    //lead.HttpUserAgent = navigator.userAgent; //JLFranco
    lead.HttpUserAgent = this.windowService.navigatorUserAgent;
    //lead.URL = window.location.href; //JLFranco
    lead.URL = this.windowService.href || '';
    lead.RecordsForSMSReservedID = lead.RecordsForSMSReservedAutoID
    lead.WebSessionID = this.storage?.getItem('Session-Guid') ?? null 

    var utmSource = lead.utm_source;
    var OfferIDGeneral = null;
    var ThreadIDGeneral = null;

    if(utmSource) {
      var objUTMSource = utmSource.split("_");
      if (objUTMSource != undefined) {
          if (objUTMSource.length == 3) {
              if (!isNaN(objUTMSource[1]))
                  if (!isNaN(objUTMSource[2])) {
                      OfferIDGeneral = parseInt(objUTMSource[1]);
                      ThreadIDGeneral = parseInt(objUTMSource[2]);
                  }
          }
      }

    }

    var utmCampaign = lead.utm_campaign;
    var lastOffer = null;

    if (utmCampaign) {
        if (utmCampaign.includes("RMK")) {
            var cmp = utmCampaign.split('_');
            if (cmp.length > 1) {
                lastOffer = cmp[1];
            }
        }
    }



    lead.OfferID = OfferIDGeneral;
    lead.ThreadID = ThreadIDGeneral;

    //lead.URL = window.location.href; //JLFranco
    lead.URL = this.windowService.href || '';

    if (!lead.RecordsForSMSReservedID && lead.RecordsForSMSReservedAutoID) {
        lead.RecordsForSMSReservedID = lead.RecordsForSMSReservedAutoID;
    }
    
    const numericFields = ['LoanAmount', 'BalanceLoan2', 'CashOut', 'EstimatedHomeValue'];
    numericFields.forEach(field => {
      if (lead[field]) {
        lead[field] = Number(lead[field]) || 0;
      }
    });

    if (lead.EstimatedHomeValue) {
      const homeValue = Number(lead.EstimatedHomeValue);
      const loan1 = Number(lead.LoanAmount) || 0;
      const loan2 = Number(lead.BalanceLoan2) || 0;
      const cashOut = Number(lead.CashOut) || 0;
      
      lead.CLTV = (loan1 + loan2 + cashOut) / homeValue;
    }

    lead.ExternID = formData['lpkey'] || formData['lpKey'] || formData['LPKey'] || formData['LPKEY'] 
    lead.TCPA = this.getTcpaDisclaimer();

    const bestKnownToken = this.getBestKnownJornayaTokenNow();
    lead.LeadIDTocken = bestKnownToken;
    lead.JornayaToken = bestKnownToken;
    this.logJornayaDebug('form-submission:lead-token-read', {
      leadIdLen: (lead.LeadIDTocken || '').length,
      jornayaLen: (lead.JornayaToken || '').length,
      tokenMasked: this.maskJornayaToken(lead.JornayaToken || ''),
      offerId: lead.OfferID ?? null,
      threadId: lead.ThreadID ?? null,
    });
    if (this.isDebugJornayaEnabled() && (!lead.LeadIDTocken || !lead.JornayaToken)) {
      console.trace('[JORNAYA-DEBUG][form-submission] trace=lead-token-empty-at-prepareLeadData', {
        offerId: lead.OfferID ?? null,
        threadId: lead.ThreadID ?? null,
        leadIdLen: (lead.LeadIDTocken || '').length,
        jornayaLen: (lead.JornayaToken || '').length,
        tokenMasked: this.maskJornayaToken(lead.JornayaToken || ''),
      });
    }
    lead.SR_TOKEN = this.getInputValue('SR_TOKEN');
    lead.xxTrustedFormCertUrl = this.getInputValue('xxTrustedFormCertUrl');

    if(!lead.SourceID) {
      lead.SourceID = 0

    }
    for (let i = 1; i <= 10; i++) {      
      if(!lead[`CustomVar${i}`]) {
        lead[`CustomVar${i}`] = this.getCustomVar(i);
      }
    }

    if (!lead.CustomVar4) {
      //lead.CustomVar4 = window.location.hostname; //JLFranco
      lead.CustomVar4 = this.windowService.window?.location.hostname || '';
    }
    this.fireGoogleAnalyticsEvents();



    return lead;
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'withCredentials': 'true',
      'Authorization': 'true',
      'Token': this.environment.apiToken
    });
  }

  private getSubmissionUrl(): string {
    return `${this.environment.apiBaseUrl}/SaveLeads`;
  }

   async handleSubmissionResponse(response: any, lead: any): Promise<void> {
    if (!response) {
      throw new Error('Empty response from server');
    }
    
      if(lead.ThankYouPageMode === '1') {
        const formData = this.formDataService.getCurrentFormData();
        lead = this.prepareLeadData(formData, '');
      }

    
    const thanksSubId = lead.ThanksSubID || '';
    const thankYouRoute = await this.thankYouRouteService.resolve(thanksSubId);
    this.thankYouRouteService.sendThankyouPageRoute(thanksSubId);

    switch ((thankYouRoute.provider || '').toLowerCase()) {
      case 'mao':
        this.maoThankYouPage(lead);
        break;
      case 'tandem':
        this.tandemThankYouPage(lead);
        break;
      case 'upsell':
        this.upSellThankYouPage(lead);
        break;
      default:
        this.internalThankYouPage(lead);
        break;
    }

  }

  private async handleSubmissionError(error: any): Promise<void> {
    const lead = this.formDataService.getCurrentFormData();
    const thanksSubId = lead.ThanksSubID || '';

    if (thanksSubId === 'MA') {
      this.router.navigate(['/error'], { 
        queryParams: { 
          zip: lead.Zip,
          state: lead.State,
        }
      });
    } else {
    }
  }

  private generateUUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  private getTcpaDisclaimer(): string {
    if (!this.isBrowser) {
      return '';
    }

    const disclaimerElements = [
      'label.disclaimer', 'label.disclosure', 
      'span.disclaimer', 'div.disclaimer', 
      'span.disclosure', 'div#srDisclosure'
    ].join(',');

    //const elements = document.querySelectorAll(disclaimerElements); //JLFranco
    const elements = this.windowService.document?.querySelectorAll(disclaimerElements) || [];
    
    for (let i = 0; i < elements.length; i++) {
      const text = (elements[i].textContent || '').trim();
      if (text) return text;
    }

    // const tcpaText = $('#leadid_tcpa_disclosure').parent().text();
    const tcpaText = ""
    return tcpaText.replace(/^[^a-zA-Z]+|[^a-zA-Z.]+$/g, '') + '-';
  }

  private getInputValue(name: string): string {
    if (!this.isBrowser) {
      return '';
    }

    //const element = document.querySelector(`input[name="${name}"]`); //JLFranco
    const element = this.windowService.document?.querySelector(`input[name="${name}"]`);
    if (name === 'universal_leadid') {
      const valueLen = element ? ((element as HTMLInputElement).value || '').trim().length : 0;
      const value = element ? ((element as HTMLInputElement).value || '').trim() : '';
      this.updateJornayaTokenRuntimeCache(value);
      this.logJornayaDebug('form-submission:getInputValue', {
        hasElement: !!element,
        valueLen,
        tokenMasked: this.maskJornayaToken(value),
      });
      if (this.isDebugJornayaEnabled() && valueLen === 0) {
      console.trace('[JORNAYA-DEBUG][form-submission] trace=getInputValue-universal_leadid-empty', {
          hasElement: !!element,
          valueLen,
          tokenMasked: this.maskJornayaToken(value),
        });
      }
    }
    return element ? (element as HTMLInputElement).value : '';
  }

  /**
   * 2026-08-03
   * Contexto:
   * Jornaya/LeadID token puede llegar unos segundos despues de los primeros eventos.
   * Actualmente se registran eventos tempranos cuando el token aun no esta disponible.
   *
   * Acción:
   * - mantener en memoria únicamente un caché de token en tiempo de ejecución (solo memoria, sin almacenamiento local/sesión).
   * - Siempre sobrescribir el caché con el último token no vacío visto en la ejecución actual de la página.
   * - Para el envio final (submit), esperar una ventana corta y acotada cuando el token venga vacio.
   
   */
  private getBestKnownJornayaTokenNow(): string {
    const inputValue = this.getInputValue('universal_leadid').trim();
    if (inputValue) {
      this.updateJornayaTokenRuntimeCache(inputValue);
      return inputValue;
    }

    return this.jornayaTokenRuntimeCache;
  }

  private updateJornayaTokenRuntimeCache(token: string): void {
    if (!token) {
      return;
    }

    this.jornayaTokenRuntimeCache = token;
  }

  private async getJornayaTokenForFinalSubmit(): Promise<string> {
    const currentToken = this.getBestKnownJornayaTokenNow();
    if (currentToken) {
      return currentToken;
    }
    return this.waitForJornayaTokenIfNeeded(800, 100);
  }

  private async waitForJornayaTokenIfNeeded(maxMs: number = 800, intervalMs: number = 100): Promise<string> {
    const startedAt = this.telemetryService.startTimer();

    while (this.telemetryService.stopTimer(startedAt) < maxMs) {
      await new Promise(resolve => setTimeout(resolve, intervalMs));
      const token = this.getBestKnownJornayaTokenNow();
      if (token) {
        this.logJornayaDebug('form-submission:final-token-resolved-after-wait', {
          tokenLen: token.length,
          waitedMs: Math.round(this.telemetryService.stopTimer(startedAt)),
        });
        return token;
      }
    }

    this.logJornayaDebug('form-submission:final-token-wait-timeout', {
      maxMs,
      intervalMs,
    });
    return '';
  }

  private isDebugJornayaEnabled(): boolean {
    const search = this.windowService.locationSearch;
    if (!search) return false;
    const value = new URLSearchParams(search).get('debugJornaya')?.trim().toLowerCase();
    return value === '1' || value === 'true' || value === 'yes';
  }

  private logJornayaDebug(stage: string, details: Record<string, unknown> = {}): void {
    if (!this.isDebugJornayaEnabled()) return;
    console.log(`[JORNAYA-DEBUG][form-submission] stage=${stage}`, details);
  }

  private maskJornayaToken(token: string): string {
    if (!token) {
      return '';
    }

    const normalized = token.trim();
    if (normalized.length <= 8) {
      return `${normalized.slice(0, 2)}...${normalized.slice(-2)}`;
    }

    return `${normalized.slice(0, 6)}-...-${normalized.slice(-2)}`;
  }

  private getCustomVar(index: number): string {

    return '';
  }

  private fireGoogleAnalyticsEvents(): void {
    // Implementa tus eventos de Google Analytics
    // gtag('config', 'G-9NLDMWHT0N');
    // gtag('event', 'page_view', {
    //   page_title: 'LeadSubmit',
    //   page_location: window.location.origin + '/LeadSubmit'
    // });

    // gtag('event', 'generate_lead', {
    //   currency: 'USD',
    //   value: 1.00
    // });
  }

  private buildIMLPRedirectUrl(lead: any, soldStatus: string): string {

    return `https://a.3800trk.com/c/1970657/1760314/18080?${this.buildQueryString({
      PRODUCT: 'PP_REFI',
      LEAD_STATUS: soldStatus,
      FNAME: lead.FName,
      LNAME: lead.LName,
      ZIP: lead.Zip,
      CITY: lead.City,
      STATE: lead.State,
      EMAIL: lead.Email,
      PRI_PHONE: lead.Phone,
      ADDRESS: lead.Address,
      EST_VAL: lead.EstimatedHomeValue,
      BAL_ONE: lead.LoanAmount,
      ADD_CASH: lead.CashOut,
      VA_STATUS: lead.VAStatus ? "yes" : "no",
      CRED_GRADE: lead.CreditRating,
      PROP_DESC: this.getPropertyDescription(lead.PropertyType)
    })}`;
  }

  private buildQueryString(params: {[key: string]: any}): string {
    return Object.keys(params)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key] || '')}`)
      .join('&');
  }

  private getPropertyDescription(propertyType: string): string {
    const mappings: {[key: string]: string} = {
      'Single Family': 'single_fam',
      'MultiFamily': 'multi_fam',
      'Condominium': 'condo',
      'Manufactured or Mobile Home': 'mobile_home'
    };
    return mappings[propertyType] || 'unknown';
  }

  internalThankYouPage(lead: any) {
    if (!this.isBrowser) {
      return;
    }

    //var body = document.querySelector('body') as HTMLElement; //JLFranco
    var body = this.windowService.document?.querySelector('body') as HTMLElement;
    //var formFlow = document.querySelector('app-form-dynamic-v1') as HTMLElement; //JLFranco
    var formFlow = this.windowService.document?.querySelector('app-form-dynamic-v1') as HTMLElement;
    body.style.height = '100vh';
    if(formFlow) {
      
      formFlow.style.display = 'none'
    }

    //var thankYouPage = document.querySelector('app-thank-you-page-v1') as HTMLElement; //JLFranco
    var thankYouPage = this.windowService.document?.querySelector('app-thank-you-page-v1') as HTMLElement;
    if(thankYouPage) {
      
      thankYouPage.style.display = 'block'
    }

    this.virtualPageViewService.trackThankYouView({ thankYouProvider: 'internal' });
    this.trackThankYouViewed('internal', lead);
    this.trackIncrementalMonetizationThankYou('internal', lead);

    this.formDataService.updateCurrentStep(0); // Reset step after submission

  }

  maoThankYouPage(lead: any) {
    if (!this.isBrowser) {
      return;
    }

    this.lead$.next(lead);
   
    //var formFlow = document.querySelector('app-form-dynamic-v1') as HTMLElement; //JLFranco
    var formFlow = this.windowService.document?.querySelector('app-form-dynamic-v1') as HTMLElement;
    if(formFlow) {
      formFlow.style.display = 'none'
    }

    //var thankYouPage = document.querySelector('app-thank-you-page-mao') as HTMLElement; //JLFranco
    var thankYouPage = this.windowService.document?.querySelector('app-thank-you-page-mao') as HTMLElement;
    if(thankYouPage) {
      thankYouPage.style.display = 'block'
    }

    this.virtualPageViewService.trackThankYouView({ thankYouProvider: 'mao' });
    this.trackThankYouViewed('mao', lead);
    this.trackIncrementalMonetizationThankYou('mao', lead);

    this.formDataService.updateCurrentStep(0); // Reset step after submission

  }

  tandemThankYouPage(lead: any) {
    if (!this.isBrowser) {
      return;
    }

    this.lead$.next(lead);
   
    //var formFlow = document.querySelector('app-form-dynamic-v1') as HTMLElement; //JLFranco
    var formFlow = this.windowService.document?.querySelector('app-form-dynamic-v1') as HTMLElement;
    if(formFlow) {
      formFlow.style.display = 'none'
    }

    //var thankYouPage = document.querySelector('app-thank-you-page-mao') as HTMLElement; //JLFranco
    var thankYouPage = this.windowService.document?.querySelector('app-thank-you-page-tandem') as HTMLElement;
    if(thankYouPage) {
      thankYouPage.style.display = 'block'
    }

    this.virtualPageViewService.trackThankYouView({ thankYouProvider: 'tandem' });
    this.trackThankYouViewed('tandem', lead);

    this.formDataService.updateCurrentStep(0); // Reset step after submission



  }

  upSellThankYouPage(lead: any) {
    if (!this.isBrowser) {
      return;
    }

    this.lead$.next(lead);
   
  
    var formFlow = this.windowService.document?.querySelector('app-form-dynamic-v1') as HTMLElement;
    if(formFlow) {
      formFlow.style.display = 'none'
    }

    var thankYouPage = this.windowService.document?.querySelector('app-thank-you-page-upsell') as HTMLElement;
    if(thankYouPage) {
      thankYouPage.style.display = 'block'
    }

    this.virtualPageViewService.trackThankYouView({ thankYouProvider: 'upsell' });
    this.trackThankYouViewed('upsell', lead);

    this.formDataService.updateCurrentStep(0);

  }  

  getLeadObservable(): Observable<any> {
    return this.lead$.asObservable();
  }

  private trackIncrementalMonetizationThankYou(thankYouType: 'internal' | 'mao', lead: any): void {
    const urlParams = new URLSearchParams(this.windowService.locationSearch);
    this.telemetryService.trackEvent('incremental_monetization_thank_you_viewed', {
      thankYouType,
      journeyStage: 'incremental_monetization_thank_you',
      pageSequence: 'final',
      thanksSubId: lead?.ThanksSubID || urlParams.get('ThanksSubID') || '',
      campaign: lead?.Campaign || urlParams.get('Campaign') || '',
      subId: lead?.SubID || urlParams.get('SubID') || '',
    });
  }

  private trackThankYouViewed(thankYouProvider: string, lead: any): void {
    const urlParams = new URLSearchParams(this.windowService.locationSearch);
    this.telemetryService.trackEvent('thank_you_viewed', {
      thankYouProvider,
      journeyStage: 'incremental_monetization_thank_you',
      pageSequence: 'final',
      thanksSubId: lead?.ThanksSubID || urlParams.get('ThanksSubID') || '',
      campaign: lead?.Campaign || urlParams.get('Campaign') || '',
      subId: lead?.SubID || urlParams.get('SubID') || '',
    });
  }


}
